import { render, staticRenderFns } from "./certificateTransformList.vue?vue&type=template&id=d6873e18&scoped=true&"
import script from "./certificateTransformList.vue?vue&type=script&lang=js&"
export * from "./certificateTransformList.vue?vue&type=script&lang=js&"
import style0 from "./certificateTransformList.vue?vue&type=style&index=0&id=d6873e18&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6873e18",
  null
  
)

export default component.exports